module.exports = __webpack_public_path__ + "static/media/acct_user-guide-updates.4b281ad9.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/acct_user-guide-updates.md
// module id = 1080
// module chunks = 0